import MenuItemsContainer from "./MenuItemsContainer";
import MenuItemsStore from "./MenuItemsStore";

export default MenuItemsStore(MenuItemsContainer)